export const soldRankingReport = {
	tabTitle: "Ventas por productos",
	pageTitle: "Ventas por productos",
	pageDescription: "Informe comparativo entre operadores y sus ventas.",
	exportReport: "Exportar informe",
	groupedView: "Visualización agrupada",
	selectPeriod: "Seleccione el período",
	searchCategory: "Categoría",
	searchCategoryPlaceholder: "Buscar categoría",
	searchProduct: "Producto",
	searchProductPlaceholder: "Buscar producto",
	filename: "informe_de_ventas",
	table: {
		columns: {
			position: "Posición",
			product: "Producto",
			count: "Cantidad",
			totalSold: "Total",
			price: "Precio",
			discount: "Descuento",
		},
		withoutInfo: "Sin información para mostrar",
	},
	productSoldTable: {
		columns: {
			waiter: "Mesero",
			count: "Cantidad",
			price: "Precio",
			discount: "Descuento",
			total: "Total",
		},
		withoutInfo: "Sin información para mostrar",
	},
	totalizers: {
		highestSeller: "Mayor operador",
		totalSellerSold: "Total del operador",
	},
};
